import { render, staticRenderFns } from "./followList.vue?vue&type=template&id=7a083b8a&scoped=true&"
import script from "./followList.vue?vue&type=script&lang=js&"
export * from "./followList.vue?vue&type=script&lang=js&"
import style0 from "./followList.vue?vue&type=style&index=0&id=7a083b8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a083b8a",
  null
  
)

export default component.exports